import React from 'react';
import { Reveal } from '../ui/Reveal';
import { gallery } from '../../data/gallery';
export function Gallery() {
  return <section className="bg-white py-16 md:py-24" data-id="element-53" data-mp="1eeh4wjtwpntn">
      <div className="mx-auto max-w-6xl px-5 md:px-8" data-id="element-54" data-mp="1jcr373axh4jh">
        <Reveal data-id="element-55" data-mp="1jb7kz75pojf2">
          <h2 className="text-center font-display text-2xl font-black uppercase leading-tight text-ink sm:text-3xl md:text-[2.6rem]" data-id="element-56" data-mp="1jao1hm0exmyx">
            Mirá todo lo que podés
            <span className="block text-wood" data-id="element-57" data-mp="1t1sewhafwzrn">aprender a fabricar</span>
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-58" data-mp="1y0c0uhp1abk0">
          {gallery.map((item, index) => <Reveal key={item.label} delay={index * 0.03} data-id="element-59" data-mp="2215p5c6e1sdf" data-mpi={index}>
              <figure className={`overflow-hidden rounded-2xl border border-cream-line bg-cream shadow-card ${index === 0 ? 'lg:col-span-2' : ''}`} data-id="element-60" data-mp="271a6f4f4er4p">
                <figcaption className="px-5 pb-3 pt-4 font-display text-sm font-black uppercase tracking-wide text-ink md:text-base" data-id="element-61" data-mp="cniqxoa41d1c">
                  {item.label}
                </figcaption>
                <img src={item.image} alt={item.label} className={`w-full object-cover ${index === 0 ? 'aspect-[16/9]' : 'aspect-[4/3]'}`} loading="lazy" data-id="element-62" data-mp="38z8nqi3dq0mb" />
              </figure>
            </Reveal>)}
        </div>

        <Reveal delay={0.06} data-id="element-63" data-mp="k8fj8nnnmpi">
          <p className="mx-auto mt-10 max-w-2xl text-center font-display text-sm font-black uppercase leading-snug tracking-wide text-ink/70 md:text-base" data-id="element-64" data-mp="j5sxcxd86fe">
            Proyectos funcionales para aprovechar espacios y ampliar las
            posibilidades de tu taller.
          </p>
        </Reveal>
      </div>
    </section>;
}